module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f63a.ef2af7fa.svg";